// API
export const FETCH_SYSTEMS_API = 'system/list';

// QUERIES
export const QUERY_SYSTEMS_DATA = 'QUERY_SYSTEMS_DATA';
